import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import { ReactComponent as QuotesLeftIcon } from "../../images/quotes-l.svg";
import { ReactComponent as QuotesRightIcon } from "../../images/quotes-r.svg";
import { ReactComponent as ArrowLeftIcon } from "../../images/arrow-left-2-icon.svg";
import { ReactComponent as ArrowRightIcon } from "../../images/arrow-right-2-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-4.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "../../images/svg-decorator-blob-5.svg";

import "slick-carousel/slick/slick.css";

const Container = tw.div`-mx-8 px-8 relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const HeadingInfoContainer = tw.div`flex flex-col items-center font-black text-gray-800`;
const HeadingDescription = tw.p`mt-4 font-medium text-center max-w-sm`;
const HighlightedText = tw.span`bg-black text-gray-100 px-4 transform -skew-x-12 inline-block`;

const TestimonialSliderContainer = tw.div`mt-8`;
const TestimonialSlider = styled(Slider)``;
const Testimonial = tw.div`flex! flex-col items-center md:items-stretch md:flex-row md:justify-center outline-none`;
const ImageContainer = styled.div`
  ${tw`md:mx-3 lg:mx-6 w-2/3 md:w-4/12 rounded flex items-center max-w-xs md:max-w-none`}
  img {
    ${tw``}
  }
`;
const TextContainer = tw.div`text-sm text-gray-700 md:mx-3 lg:mx-6 md:w-6/12 py-4 flex flex-col justify-between`;
const QuoteContainer = tw.div`relative p-6 md:p-8 lg:p-10 mt-10 md:mt-0 font-thin`;
const Quote = tw.blockquote`text-center md:text-right font-thin text-lg lg:text-xl xl:text-2xl`;
const CustomerInfo = tw.div`px-5 lg:px-10 text-center md:text-left mt-4 md:mt-0`;
const CustomerName = tw.h5`text-center md:text-right font-bold text-lg lg:text-xl xl:text-2xl text-gray-700`;
const CustomerTitle = tw.p`text-center md:text-right font-thin text-sm text-gray-700`;

const QuotesLeft = tw(QuotesLeftIcon)`w-4 h-4 lg:w-4 lg:h-4 text-gray-700 absolute top-auto left-auto`;
const QuotesRight = tw(QuotesRightIcon)`w-4 h-4 lg:w-4 lg:h-4 text-gray-700 absolute bottom-auto right-0`;

const SliderControlButtonContainer = styled.div`
  ${tw`absolute top-0 h-full flex items-end md:items-center z-20`}
  button {
    ${tw`text-gray-700 hover:text-[#fc0606] focus:outline-none transition duration-300 transform hover:scale-125 transform -translate-y-2/3 md:translate-y-0`}
    svg {
      ${tw`w-8`}
    }
  }
`;

const NextArrow = ({ currentSlide, slideCount, ...props }) => (
  <SliderControlButtonContainer tw="right-0">
    <button {...props}>
      <ArrowRightIcon />
    </button>
  </SliderControlButtonContainer>
);
const PreviousArrow = ({ currentSlide, slideCount, ...props }) => (
  <SliderControlButtonContainer tw="left-0">
    <button {...props}>
      <ArrowLeftIcon />
    </button>
  </SliderControlButtonContainer>
);

const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute w-32 top-0 left-0 -z-10 text-gray-300 opacity-25 transform -translate-x-full`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob2
)`absolute w-32 bottom-0 right-0 -z-10 text-pink-500 opacity-15 transform translate-x-2/3 translate-y-8`;

export default () => {
  /*
   * You can modify the testimonials shown by modifying the array below
   * You can add or remove objects from the array as you need.
   */
  const testimonials = [
    {
      imageSrc:
        "IMG_0272.jpg",
      profileImageSrc:
        "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80",
      quote:
        "Nowoczesne, ekologiczne i niesamowicie skuteczne rozwiązanie. Koniec z marnowaniem papieru i tonera. System e-cenówki to przyszłość handlu, którą warto wdrożyć już dziś!",
      customerName: "mgr farm. Ewa Piskorz",
      customerTitle: "Punkt Apteczny w Inwałdzie"
    },
    // {
    //   imageSrc:
    //     "kobylka.jpg",
    //   profileImageSrc:
    //     "",
    //   quote:
    //     "W branży farmaceutycznej dokładność jest kluczowa. Dzięki systemowi od e-cenowki.pl mamy pewność, że cena na półce zawsze zgadza się z tą w systemie. Bardzo doceniamy fakt, że oprogramowanie jest autorskie – działa stabilnie i bezbłędnie.",
    //   customerName: "mgr farm. Katarzyna Ołówek",
    //   customerTitle: "Właścicielka aptek w Warszawie i Kobyłce"
    // },
    {
      imageSrc:
        "IMG_9857.jpg",
      profileImageSrc:
        "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80",
      quote:
        "Wdrożenie e-cenówek to była bardzo dobra decyzja. Zmiana cen w całej aptece zajmuje teraz kilka sekund, a nie kilka godzin. System jest intuicyjny, a nasi pracownicy mogą w końcu skupić się na obsłudze pacjentów, a nie na wycinaniu papierowych etykiet.",
      customerName: "mgr farm. Magdalena Brzozowska",
      customerTitle: "Apteka w Nowym Mieście nad Pilicą"
    },
    {
      imageSrc:
        "IMG_0389.jpg",
      profileImageSrc:
        "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80",
      quote:
        "Jako właściciel biurowca klasy A, zawsze szukam rozwiązań, które łączą nowoczesny design z funkcjonalnością. Wdrożenie systemu elektronicznych etykiet przed wejściem do budynku oraz na drzwiach poszczególnych biur okazało się strzałem w dziesiątkę.",
      customerName: "Sławomir Golenko",
      customerTitle: "właściciel biurowca Plantowa 5"
    },
  ];
  return (
    <Container>
      <Content>
        <HeadingInfoContainer>
          <HeadingTitle>Przykładowe wdrożenia i opinie.</HeadingTitle>
          <HeadingDescription></HeadingDescription>
        </HeadingInfoContainer>
        <TestimonialSliderContainer>
          <TestimonialSlider nextArrow={<NextArrow />} prevArrow={<PreviousArrow />}>
            {testimonials.map((testimonial, index) => (
              <Testimonial key={index}>
                <ImageContainer>
                  <img src={testimonial.imageSrc} alt={testimonial.customerName} />
                </ImageContainer>
                <TextContainer>
                  <QuoteContainer>
                    {/* <QuotesLeft /> */}
                    <Quote>{testimonial.quote}</Quote>
                    {/* <QuotesRight /> */}
                  </QuoteContainer>
                  <CustomerInfo>
                    <CustomerName>{testimonial.customerName}</CustomerName>
                    <CustomerTitle>{testimonial.customerTitle}</CustomerTitle>
                  </CustomerInfo>
                </TextContainer>
              </Testimonial>
            ))}
          </TestimonialSlider>
        </TestimonialSliderContainer>
      </Content>
      {/* <DecoratorBlob1 />
      <DecoratorBlob2 /> */}
    </Container>
  );
};
